import { Box,Typography,ButtonBase } from '@mui/material'
import React from 'react'
import { useState } from 'react';
import { useNavigate } from 'react-router';
import TagButton from '../TagButton/TagButton';

const Discover = ({ onAllMenuClicked }) => {
    const [allMenu, setAllMenu] = useState(false);
    let navigate = useNavigate();
  return (
    <>
        <Box component='container' sx={{
            width:'100%',
            
        }}>
            <Box sx={{
                display:'flex',
                flexDirection: {lg: 'row', md: 'row', sm: 'column', xs: 'column'},
                justifyContent:'start',
                mt:{lg: '50px', md: '0px', sm: '0px', xs: "0px"},
                mb:'20px'
            }}>
                <Box >
                    <ButtonBase onClick={() => {
                        setAllMenu(true);
                        onAllMenuClicked();
                    }} sx={{
                        // width: 306,
                        width: '100%',
                        //  height: 176,
                         height: ' 100%',
                          borderRadius: "8px"
                    }}>
                       <ButtonBase onClick={()=> allMenu? navigate('/MealPlan'):""}><img alt="complex" src={allMenu ? require("../../../assets/plan.png") : "./images/banner-content.svg"} width="100%"/></ButtonBase> 
                    </ButtonBase>
                </Box>
                <Box>
                
                    <Typography
                    // gutterBottom
                    component="div"
                    sx={{
                        fontWeight: "600",
                        fontSize: {lg: "40px", md: "40px", sm: "30px", xs: "25px"},
                        lineHeight: {lg: "56px", md: "56px", sm: "56px", xs: "40px"},
                        paddingLeft: {lg: "32px", md: "32px", sm: "0px", xs: "0px"},
                        // textAlign: {sm: 'center'}
                        marginTop: {lg: "0px", md: "0px", sm: "30px", xs: "20px"}
                    }}
                    >
                    Discover Top Menu
                    </Typography>
                    <Typography
                    // className="typography1"
                    // gutterBottom
                    sx={{
                        
                        fontSize: {lg: "18px", md: "18px", sm: "16px", xs: "16px"},
                        fontWeight: "400",
                        lineHeight: "26.1px",
                        letterSpacing: "0.015em",
                        paddingLeft: {lg: "32px",
                         md: "32px", 
                        //  sm: "90px", 
                         xs: "0px"},
                        justifyContent: "center",
                        // width: "100%",
                        width: {lg: '729.09px', md: '729.09px', sm: '666px', xs: 'auto'},
                        // textAlign: {sm: 'center'}
                    }}
                    >
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s.
                    </Typography>
                    <Box sx={{
                        mt:'20px'
                    }}>
                        <Box sx={{
                            paddingLeft: {lg: "32px", md: "32px", sm: "0px", xs: "0px"},
                            marginTop: {lg: "0px", md: "0px", sm: "10px", xs: "10px"}
                        }}
                        >
                        <TagButton/>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    </>
  )
}

export default Discover